import UpdateReplacementDelivery from "../../../../components/@documents/replacement_delivery/UpdateReplacementDelivery";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ReplacementDeliveryUpdatePage() {

    return (
        <UpdateReplacementDelivery 
            routeType={routeTypes.workstation}
        />
    )
}